import styled from 'styled-components'

import CandidateImageBase, {
  ICandidateImage,
  InnerCircle,
} from '@/app/2023/consejo/components/CandidateImage'
import CircleBase from '@/app/components/CircleMesh/Circle'

const FadeCandidate = ({
  className,
  color,
  imagePath,
  isSelected,
  width = '100%',
  ...props
}: ICandidateImage) => (
  <Wrapper className={className}>
    <CandidateImage
      color={color}
      imagePath={imagePath}
      width={width}
      {...props}
    >
      <Circle
        color={color}
        isSelected={isSelected}
        width={width}
      />
    </CandidateImage>
  </Wrapper>
)

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`
const Circle = styled(CircleBase)<{ width: string; isSelected: boolean | undefined }>`
  width: ${({ width }) => width};
  transition: opacity 0.3s ease-in-out;
  position: absolute;
  ${({ isSelected }) => isSelected && 'opacity: 0;'}
  :hover {
    opacity: 0;
  }
`

const CandidateImage = styled(CandidateImageBase)<{ width: string }>`
  width: ${({ width }) => width};

  ${InnerCircle} {
    width: ${({ width }) => width};
    border: 0px;
  }
`

export default FadeCandidate
